<div class="project-detail-container" *ngIf="project$ | async as project; else loading" fxLayout="column">
  <mat-toolbar class="info-toolbar" [ngStyle]="{ left: headerLeft + 'px' }">
    <div fxLayout="row" fxLayoutAlign="space-between" style="width: 100%">
      <div style="margin-left: 45px" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
        <div class="back-holder" (click)="goBack()" aria-label="Back">
          <button mat-button class="back header-button edit-button">
            <mat-icon>arrow_back</mat-icon>
            <span>Back</span>
          </button>
        </div>
        <div style="font-size: 16px; font-weight: 600; color: #fff">
          {{ project && project.name }}
        </div>
        <div style="font-size: 14px; color: #9e9ba2; margin-top: 4px">
          {{ project.addressLine1 ? project.addressLine1 : "" }}
          {{ project.addressLine2 }} {{ project.area }} {{ project.state }}
          {{ project.postCode }}
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center">
        <button mat-button (click)="editProject()" class="header-button edit-button" style="margin-right: 45px"
                *ngIf="tabService.tabIndex === 0">
          Edit Project
        </button>

        <button mat-button (click)="openAddDialog()" class="header-button" style="margin-right: 45px" *ngIf="
            tabService.tabIndex === 1 &&
            project &&
            project.projectTypes[0].id !== 4
          ">
          <mat-icon style="
              margin-bottom: 2px;
              width: 16px;
              height: 16px;
              font-size: 16px;
              margin-right: 4px;
            ">
            add
          </mat-icon>
          Add Property
        </button>

        <button mat-button (click)="openEditFloorPlanDialog(false)" class="header-button" style="margin-right: 45px"
                *ngIf="
            tabService.tabIndex === 2 &&
            project &&
            project.projectTypes[0].id !== 4
          ">
          <mat-icon style="
              margin-bottom: 2px;
              width: 16px;
              height: 16px;
              font-size: 16px;
              margin-right: 4px;
            ">
            add
          </mat-icon>
          Add Floorplan
        </button>

        <button mat-button class="header-button" style="margin-right: 45px" (click)="handleAddLot()" *ngIf="
            tabService.tabIndex === 1 &&
            project &&
            project.projectTypes[0].id === 4
          ">
          <mat-icon style="
              margin-bottom: 2px;
              width: 16px;
              height: 16px;
              font-size: 16px;
              margin-right: 4px;
            ">
            add
          </mat-icon>
          Add Lot
        </button>

        <button mat-button (click)="addEoi()" class="header-button" style="margin-right: 45px" *ngIf="
            (tabService.tabIndex === 3 &&
              project &&
              project.projectTypes[0].id !== 4) ||
            (tabService.tabIndex === 3 &&
              project &&
              project.projectTypes[0].id === 4)
          ">
          <mat-icon style="
              margin-bottom: 2px;
              width: 16px;
              height: 16px;
              font-size: 16px;
              margin-right: 4px;
            ">
            add
          </mat-icon>
          Add EOI
        </button>

        <button mat-button class="header-button" style="margin-right: 45px" (click)="addBuildingType()" *ngIf="
            tabService.tabIndex === 2 &&
            project &&
            project.projectTypes[0].id === 4
          ">
          <mat-icon style="
              margin-bottom: 2px;
              width: 16px;
              height: 16px;
              font-size: 16px;
              margin-right: 4px;
            ">
            add
          </mat-icon>
          Add Building Type
        </button>

        <button mat-button (click)="openAddDocumentDialog()" class="header-button edit-button"
                style="margin-right: 45px" *ngIf="tabService.tabIndex === 5">
          <mat-icon style="
              margin-bottom: 2px;
              width: 16px;
              height: 16px;
              font-size: 16px;
              margin-right: 4px;
            ">
            add
          </mat-icon>
          Add Document
        </button>
      </div>
    </div>
  </mat-toolbar>

  <mat-tab-group class="project-detail-tab" [(selectedIndex)]="this.tabService.tabIndex"
                 (selectedTabChange)="selectChange()">
    <mat-tab label="Details">
      <div class="detail-container" fxLayout="column">
        <ng-container *ngIf="!isEditProject">
          <!-- swiper images -->
          <div *ngIf="
              project && project.images && project.images.length > 0;
              else imageElseBlock
            ">
            <div class="photo-operation" *ngIf="project.videoURL||project.vrURLs">
              <!-- <div class="item" (click)="openPhotoDialog()">
                                <img style="width: 20px;" src="./assets/images/photo-icon.png">
                            </div> -->
              <div class="item fz_16 fw_600" (click)="openVrLink()" *ngIf="project.vrURLs">
                3D
              </div>
              <div class="item" (click)="openVideoDialog()" *ngIf="project.videoURL">
                <mat-icon>smart_display</mat-icon>
              </div>
            </div>

            <div class="image_box project_image1" *ngIf="project.images.length === 1">
              <img [src]="
                    SERVER_URL +
                    'images/' +
                    project.projectCode +
                    '/images/' +
                    project.images[0].fileName
                  " class="first_image"
                   style="width: 100%; height: 100%; object-fit: contain"
                   *ngIf="project.images[0]"
                   [attr.alt]="project?.name || 'project image'"
                   (click)="openPhotoDialog()"/>
            </div>
            <div class="image_box project_image2" *ngIf="project.images.length === 2">
              <div style="width: calc(50% - 16px)" class="project_image_son"
                   *ngFor="let image of project.images; trackBy: trackByIdx">
                <img [src]="
                SERVER_URL +
                'images/' +
                project.projectCode +
                '/images/' +
                image.fileName
              " class="first_image" loading="lazy" [attr.alt]="project?.name || 'project image'"
                     (click)="openPhotoDialog()"/>
              </div>
            </div>
            <div class="image_box project_image2" *ngIf="project.images.length === 3">
              <div style="width: calc(33% - 16px)" *ngFor="let image of project.images; trackBy: trackByIdx"
              >
                <img [src]="
                SERVER_URL +
                'images/' +
                project.projectCode +
                '/images/' +
                image.fileName
              " class="first_image" loading="lazy" [attr.alt]="project?.name || 'project image'"
                     (click)="openPhotoDialog()"/>
              </div>
            </div>
            <div class="image_box project_image4" *ngIf="project.images.length === 4">
              <div style="width: calc(50% - 16px)" class="project_image_son"
                   *ngFor="let image of project.images; trackBy: trackByIdx">
                <img [src]="
                SERVER_URL +
                'images/' +
                project.projectCode +
                '/images/' +
                image.fileName
              " class="second_image" loading="lazy" [attr.alt]="project?.name || 'project image'"
                     (click)="openPhotoDialog()"/>
              </div>

            </div>


            <div class="image_box flex justify-between" *ngIf="project.images.length >= 5">
              <div style="width: calc(50% - 16px)">
                <img [src]="
                    SERVER_URL +
                    'images/' +
                    project.projectCode +
                    '/images/' +
                    project.images[0].fileName
                  " class="first_image" *ngIf="project.images[0]" [attr.alt]="project?.name || 'project image'"
                     (click)="openPhotoDialog()"/>
              </div>

              <div style="width: calc(25% - 16px)">
                <div>
                  <img [src]="
                      SERVER_URL +
                      'images/' +
                      project.projectCode +
                      '/images/' +
                      project.images[1].fileName
                    " class="second_image" loading="lazy" *ngIf="project.images[1]"
                       [attr.alt]="project?.name || 'project image'" (click)="openPhotoDialog()"/>
                </div>
                <div>
                  <img [src]="
                      SERVER_URL +
                      'images/' +
                      project.projectCode +
                      '/images/' +
                      project.images[2].fileName
                    " class="second_image mt_15" loading="lazy" *ngIf="project.images[2]"
                       [attr.alt]="project?.name || 'project image'" (click)="openPhotoDialog()"/>
                </div>
              </div>
              <div style="width: calc(25% - 16px)">
                <div>
                  <img [src]="
                      SERVER_URL +
                      'images/' +
                      project.projectCode +
                      '/images/' +
                      project.images[3].fileName
                    " class="second_image" loading="lazy" *ngIf="project.images[3]"
                       [attr.alt]="project?.name || 'project image'" (click)="openPhotoDialog()"/>
                </div>
                <div class="mt_15 second_image black_bg fc_DEDEDE fz_14 flex align-center justify-center"
                     *ngIf="project.images.length>4">
                  <img [src]="
                  SERVER_URL +
                  'images/' +
                  project.projectCode +
                  '/images/' +
                  project.images[4].fileName
                " class="second_image" loading="lazy" *ngIf="project.images[4]"
                       [attr.alt]="project?.name || 'project image'" style="opacity: 0.1;"/>
                  <div (click)="openPhotoDialog()" class="cursor_pointer"
                       style="position: absolute;text-decoration-line: underline;" *ngIf="project.images.length>5">
                    View more
                  </div>
                </div>
                <!-- <div class="mt_15 second_image black_bg fc_DEDEDE fz_14 flex align-center justify-center"
                  *ngIf="project.images.length>4">
                  <img [src]="
                  SERVER_URL +
                  'images/' +
                  project.projectCode +
                  '/images/' +
                  project.images[4].fileName
                " class="second_image" *ngIf="project.images[4]" />
                  <div (click)="openPhotoDialog()" class="cursor_pointer">
                    View more
                  </div>
                </div> -->
              </div>
              <div></div>
            </div>
          </div>
          <ng-template #imageElseBlock>
            <div style="height: 80px"></div>
          </ng-template>

          <div fxLayout="row" fxLayout.sm="column" fxLayoutAlign="center">
            <div fxLayout="column" class="detail-content" fxLayoutGap="27px">
              <div fxLayout="row" fxLayoutAlign="space-between" class="section detail-title">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <ng-container *ngIf="project.logo">
                    <img [src]="
                        SERVER_URL +
                        'images/' +
                        project.projectCode +
                        '/images/' +
                        project.logo.fileName
                      " style="
                        width: auto;
                        height: 48px;
                        max-width: 200px;
                        object-fit: contain;
                      "/>
                  </ng-container>
                  <ng-container *ngIf="project && !project.logo">
                    <img src="./assets/images/default-project-logo.jpg"
                         style="width: auto; height: 60px; object-fit: contain"/>
                  </ng-container>
                  <div style="margin-left: 16px">
                    <div class="fc_DEDEDE">{{ project && project.name }}</div>
                    <div style="font-size: 14px; color: #9e9ba2; margin-top: 4px">
                      {{ project.addressLine1 ? project.addressLine1 : "" }}
                      {{ project.addressLine2 }}
                      {{ project.area }}
                      {{ project.state }} {{ project.postCode }}
                    </div>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px">
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="flex align-center fz_14 mr_15">
                      <div style="width:5px;height:5px;border-radius:50%;background: #FFAA21;" class="{{satusShow}}bg">
                      </div>
                      <div [ngClass]="satusShow" style="margin-left: 5px;color: #FFAA21;">{{ satusShow }}</div>
                    </div>

                    <!-- <div (click)="project.showBox = true; $event.stopPropagation()">
                      <img class="dot_image" src="./assets/images/black/dot.png" />
                    </div> -->

                    <div class="operate_box" *ngIf="project.showBox" (mouseleave)="project.showBox = false">
                      <img src="./assets/images/black/black_close.png" class="black_close" (click)="
                          project.showBox = false; $event.stopPropagation()
                        "/>
                      <!-- <div class="operate_text fz_14"
                                                (click)="project.showBox=false;$event.stopPropagation()">Add to
                                                favourites</div> -->
                      <div class="operate_text fz_14" (click)="
                          editProject();
                          project.showBox = false;
                          $event.stopPropagation()
                        ">
                        Edit project
                      </div>
                      <div class="operate_text fz_14" (click)="
                          openManulUpdateDialog();
                          project.showBox = false;
                          $event.stopPropagation()
                        ">
                        Review
                      </div>
                    </div>
                  </div>
                  <!-- <div fxLayout="row" fxLayoutAlign="start end" fxLayoutGap="5px">
                                        <div style="font-size: 16px; line-height: 16px;color: #352942;">
                                            {{project.historyUsers}}</div>
                                        <div style="font-size: 14px;opacity: 0.5;color: #352942;">Viewed</div>
                                    </div>
                                    <div style="border-left: 1px solid #ddd; height: 16px; width: 1px"></div>
                                    <div fxLayout="row" fxLayoutAlign="start end" fxLayoutGap="5px">
                                        <div style="font-size: 16px; line-height: 16px;color: #352942;">
                                            {{project.likeUsers}}</div>
                                        <div style="font-size: 14px;opacity: 0.5;color: #352942;">Favourite</div>
                                    </div>
                                    <div style="border-left: 1px solid #ddd; height: 16px; width: 1px"></div>
                                    <div fxLayout="row" fxLayoutAlign="start end" fxLayoutGap="5px">
                                        <div style="font-size: 16px; line-height: 16px;color: #352942;">
                                            {{project.enquire}}</div>
                                        <div style="font-size: 14px;opacity: 0.5;color: #352942;">Enquiry</div>
                                    </div> -->
                </div>
              </div>

              <div fxLayout="row" fxLayout.sm="column" fxLayoutGap="27px" fxLayoutAlign="start start">
                <div fxLayout="column" fxFlex="60" fxLayoutGap="27px">
                  <div class="section">
                    <div class="section-title">Overview</div>
                    <div fxLayout="row wrap">
                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">Project Status</div>
                        <div class="attr-value" style="color: #2fdc2b">
                          <ng-container *ngIf="project.projectStatus === 1">
                            Off the market
                          </ng-container>
                          <ng-container *ngIf="project.projectStatus === 2">
                            Off the plan
                          </ng-container>
                          <ng-container *ngIf="project.projectStatus === 3">
                            Under construction
                          </ng-container>
                          <ng-container *ngIf="project.projectStatus === 4">
                            <span class="fc_2FDC2B">Completed</span>
                          </ng-container>
                        </div>
                      </div>

                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">Project Type</div>
                        <div class="attr-value">
                          {{
                            constants.PROJECT_TYPE[project.projectTypes[0].id]
                              .en
                          }}
                        </div>
                      </div>

                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">Total Units</div>
                        <div class="attr-value">{{ project.totalUnit }}</div>
                      </div>
                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">Price</div>
                        <!--                        <div class="attr-value" *ngIf="project.maxPrice !== 0 && project.minPrice !== 0">-->
                        <!--                          ${{project.minPrice ? formatNum(project.minPrice) : 0}}-->
                        <!--                          - -->
                        <!--                          ${{project.maxPrice ? formatNum(project.maxPrice) : 0}}-->

                        <!--                        </div>-->
                        <!--                        <div class="attr-value" *ngIf="project.maxPrice === 0 && project.minPrice !== 0">-->
                        <!--                          From-->
                        <!--                          ${{project.minPrice ? formatNum(project.minPrice) : 0}}-->
                        <!--                        </div>-->
                        <!--                        <div class="attr-value" *ngIf="project.maxPrice === 0 && project.minPrice === 0">-->
                        <!--                          - -->
                        <!--                        </div>-->
                        <div class="attr-value">{{ getPriceDisplay() }}</div>
                      </div>
                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">Total Area</div>
                        <div class="attr-value">
                          {{
                            project.minTotalArea !== null
                              ? project.minTotalArea
                              : 0
                          }}
                          -
                          {{
                            project.maxTotalArea !== null
                              ? project.maxTotalArea
                              : "-"
                          }}
                        </div>
                      </div>
                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">Bedroom</div>
                        <div class="attr-value"
                             *ngIf="project.minBedRoom === project.maxBedRoom">
                          {{ project.minBedRoom }}
                        </div>
                        <div class="attr-value"
                             *ngIf="project.minBedRoom !== project.maxBedRoom">
                          {{
                            (project.minBedRoom === 0)
                              ? 'Any'
                              : (project.minBedRoom !== null ? project.minBedRoom : "-")
                          }}
                          -
                          {{
                            (project.maxBedRoom === 0)
                              ? 'Any'
                              : (project.maxBedRoom !== null ? project.maxBedRoom : "-")
                          }}
                        </div>
                      </div>
                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">Bathroom</div>
                        <div class="attr-value"
                             *ngIf="project.minBathRoom === project.maxBathRoom">
                          {{ project.minBathRoom }}
                        </div>
                        <div class="attr-value"
                             *ngIf="project.minBathRoom !== project.maxBathRoom">
                          {{
                            (project.minBathRoom === 0)
                              ? 'Any'
                              : (project.minBathRoom !== null ? project.minBathRoom : "-")
                          }}
                          -
                          {{
                            (project.maxBathRoom === 0)
                              ? 'Any'
                              : (project.maxBathRoom !== null ? project.maxBathRoom : "-")
                          }}
                        </div>
                      </div>

                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">Parking Space</div>
                        <div class="attr-value"
                             *ngIf="project.minParking === project.maxParking">
                          {{ project.minParking }}
                        </div>
                        <div class="attr-value"
                             *ngIf="project.minParking !== project.maxParking">
                          {{
                            (project.minParking === 0)
                              ? 'Any'
                              : (project.minParking !== null ? project.minParking : "-")
                          }}
                          -
                          {{
                            (project.maxParking === 0)
                              ? 'Any'
                              : (project.maxParking !== null ? project.maxParking : "-")
                          }}
                        </div>
                      </div>
                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">Level</div>
                        <div class="attr-value">{{ project.level }}</div>
                      </div>
                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">Start Date</div>
                        <div class="attr-value">
                          {{
                            project.startTime ? (project.startTime | date) : "-"
                          }}
                        </div>
                      </div>
                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">End Date</div>
                        <div class="attr-value">
                          {{ project.endTime ? (project.endTime | date) : "-" }}
                        </div>
                      </div>
                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">Sunset Date</div>
                        <div class="attr-value">
                          {{
                            project.sunsetTime
                              ? (project.sunsetTime | date)
                              : "-"
                          }}
                        </div>
                      </div>
                      <div fxFlex="25" class="project-attr">
                        <div class="attr-name">Include FIRB</div>
                        <div class="attr-value">
                          {{ project.firb ? "Yes" : "No" }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="section">
                    <div class="section-title">Sales Information</div>
                    <div class="sales-attr flex justify-between border-bottom" fxLayout="row">
                      <div class="sales-name">Commission</div>
                      <div class="sales-value">
                        <ng-container *ngIf="project.commissionFeeUnit == '%'">
                          {{
                            project.commissionFee
                              ? project.commissionFee + "%"
                              : 0
                          }}
                        </ng-container>
                        <ng-container *ngIf="
                            project.commissionFeeUnit == 'AUD' &&
                            project.commissionFee
                          ">
                          A${{ project.commissionFee ? formatNum(project.commissionFee) : 0 }}
                          <!-- {{project.commissionFee ? '$ ' + project.commissionFee : 0}} -->
                        </ng-container>
                        <ng-container *ngIf="!project.commissionFeeUnit">
                          -
                        </ng-container>
                      </div>
                    </div>
                    <div class="sales-attr flex justify-between border-bottom" fxLayout="row">
                      <div class="sales-name">Holding deposit</div>
                      <div class="sales-value">
                        <ng-container *ngIf="propertyDeposit">
                          {{ propertyDeposit }}
                        </ng-container>
                        <ng-container *ngIf="!propertyDeposit">
                          -
                        </ng-container>
                      </div>
                    </div>

                    <div class="sales-attr flex justify-between" fxLayout="row">
                      <div class="sales-name">Incentives</div>
                      <div class="sales-value">
                        {{ incentives ? incentives : "-" }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section" fxFlex="40">
                  <agm-map style="width: 100%; height: 255px" [latitude]="project.latitude"
                           [longitude]="project.longitude" [zoom]="12" [styles]="customStyles">
                    <agm-marker [latitude]="project.latitude" [longitude]="project.longitude">
                    </agm-marker>
                  </agm-map>
                  <div class="map-attr border-bottom" fxLayout="row" fxLayoutAlign="space-between"
                       style="margin-top: 24px">
                    <div class="map-name">Address</div>
                    <div class="map-value">{{ address ? address : "-" }}</div>
                  </div>
                  <div class="map-attr border-bottom" fxLayout="row" fxLayoutAlign="space-between">
                    <div class="map-name">Website</div>
                    <div class="map-value website-address"
                         (click)="openLink(project.website)">
                      {{ project.website }}
                    </div>
                  </div>
                  <div class="map-attr" fxLayout="row" fxLayoutAlign="space-between">
                    <div class="map-name">Uploaded on</div>
                    <div class="map-value">{{ momentDate }}</div>
                  </div>
                  <div class="map-description">
                    <app-read-more [content]="
                        project && project.notes
                          ? project && project.notes.en
                          : '-'
                      " [limit]="270" [completeWords]="true" class="cursor_pointer">
                    </app-read-more>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="section product-table-wrap">
            <div class="section-title">Product</div>
            <div>
              <div class="product-table">
                <table mat-table [dataSource]="products" style="width: 98%">
                  <ng-container matColumnDef="unit">
                    <th mat-header-cell *matHeaderCellDef style="width: 60%">
                      Config
                    </th>
                    <td mat-cell *matCellDef="let element" class="detail_bottom">
                      <span style="cursor: pointer">{{ element.bedRoom }} B/{{ element.bathRoom }}B/{{
                          element.carParking
                        }}C</span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="level">
                    <th mat-header-cell *matHeaderCellDef style="width: 20%">
                      Area Range
                    </th>
                    <td mat-cell *matCellDef="let element" class="detail_bottom">
                      <span style="cursor: pointer">{{ element.minTotalArea }} -
                        {{ element.maxTotalArea }} m2</span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef style="width: 20%">
                      Price Range
                    </th>
                    <td mat-cell *matCellDef="let element" class="detail_bottom">
                      <span style="cursor: pointer">A${{ element.minPrice ? formatNum(element.minPrice) : 0 }}
                        - A${{ element.maxPrice ? formatNum(element.maxPrice) : 0 }}</span>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="productColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: productColumns"></tr>
                </table>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- <ng-container *ngIf="isEditProject">
                <app-edit-project (cancelEdit)="cancelEditProject()"></app-edit-project>
            </ng-container> -->
    </mat-tab>
    <mat-tab label="Properties" *ngIf="[1, 2, 3].includes(project.projectTypes[0].id)">
      <div style="
          height: 230px;
          background: #000;
          position: fixed;
          width: 100%;
          z-index: 9999;
        "></div>
      <div class="detail-container">
        <app-detail-properties [project]="project" (resetInit)="ngOnInit()"></app-detail-properties>
      </div>
    </mat-tab>
    <mat-tab label="Floorplans" *ngIf="[1, 2, 3].includes(project.projectTypes[0].id)">
      <ng-template mat-tab-label>
        <div (click)="floorplanReset()">Floorplans</div>
      </ng-template>
      <div class="detail-container">
        <app-detail-floorplans [project]="project" *ngIf="floorplanShow"
                               (resetInit)="ngOnInit()"></app-detail-floorplans>
      </div>
    </mat-tab>
    <mat-tab label="EOI" *ngIf="project && project.projectTypes[0].id != 4">
      <ng-template mat-tab-label>
        <div (click)="floorplanReset()">EOI</div>
      </ng-template>
      <div class="detail-container">
        <app-project-detail-eois [project]="project" *ngIf="showEois"></app-project-detail-eois>
      </div>
    </mat-tab>
    <mat-tab label="Lots" *ngIf="project.projectTypes[0].id === 4">
      <div class="detail-container">
        <app-project-detail-lots [project]="project"></app-project-detail-lots>
      </div>
    </mat-tab>
    <mat-tab label="Building Type" *ngIf="project && project.projectTypes[0].id === 4">
      <ng-container *ngIf="project">
        <div class="detail-container">
          <app-packages [project]="project"></app-packages>
        </div>
      </ng-container>
    </mat-tab>
    <mat-tab label="EOI" *ngIf="project && project.projectTypes[0].id === 4">
      <ng-template mat-tab-label>
        <div (click)="floorplanReset()">EOI</div>
      </ng-template>
      <div class="detail-container">
        <app-project-detail-eois [project]="project" *ngIf="showEois"></app-project-detail-eois>
      </div>
    </mat-tab>
    <mat-tab label="Gallery">
      <div class="detail-container">
        <div style="
            margin: 24px;
            background: #ffffff;
            margin: 24px;
            margin-top: 158px;
          ">
          <app-pictures [project]="project" (load)="getProjects()" (uploadPic)="uploadPic($event)"></app-pictures>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Documents">
      <div class="detail-container">
        <app-project-documents [project]="project"></app-project-documents>
      </div>
    </mat-tab>
    <mat-tab label="Analytics">
      <ng-container *ngIf="project">
        <div class="detail-container">
          <app-project-analytics [project]="project"
                                 [availableNum]="availableNum"
                                 [soldNum]="soldNum"
                                 [reserveNum]="reserveNum"></app-project-analytics>
        </div>
      </ng-container>
    </mat-tab>
    <mat-tab label="Agencies">
      <ng-template matTabContent>
        <ng-container *ngIf="project">
          <div class="detail-container">
            <app-project-cooperation [project]="project"></app-project-cooperation>
          </div>
        </ng-container>
      </ng-template>
    </mat-tab>
    <mat-tab label="Settings">
      <div class="detail-container">
        <app-project-settings [project]="project"></app-project-settings>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<ng-template #loading>
  <app-loading></app-loading>
</ng-template>
